import { Component, EventEmitter, Input, KeyValueDiffer, KeyValueDiffers, OnInit, Output } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ManualRowSortComponent } from 'src/app/dashboards/components/manual-row-sort/manual-row-sort.component';
import { SortComponent } from 'src/app/dashboards/components/sort-component/sort.component';
import { agent } from 'src/app/dashboards/models';
import { canculateGridItemSize, register } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { widgetType } from 'src/app/enums';
import { gridItem, property } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { WidgetBaseComponent } from '../../widget-base.component';

@Component({
    selector: 'app-agents-wizard',
    templateUrl: './agents-wizard.component.html',
    styleUrls: ['./agents-wizard.component.scss'],
    standalone: false
})
@register("Agents_wizard")
export class AgentswizardComponent implements OnInit, WidgetBaseComponent {
  @Input() public gridItem: gridItem;
  @Input() public isEdit: boolean;
  @Output() public completed = new EventEmitter<boolean>();
  visualTypedisabledItems: number[] = [];
  agents$: Observable<agent[]>;
  agentProperties$: Observable<property[]>;
  agentProperties: property[];
  agents: agent[];
  manualRowOrderItems: agent[];
  private agentIdDiffers: KeyValueDiffer<string, any>;

  get isManualRowOrderEnabled(): boolean {
    let isManualRowSortEnabled = ManualRowSortComponent.getIsManualRowSortEnabled(this.gridItem);

    this.nulifySetupSortingPoperties(isManualRowSortEnabled);

    return isManualRowSortEnabled;
  }

  get isSecondLevelSortingEnabled() {
    return !!this.gridItem.setup[SortComponent.firstLevelSetupColumnPropertyName];
  }

  get isSortingVisible() {
    let agentsCount = this.gridItem.setup.agentIds?.length || 0;
    let propsCount = this.gridItem.setup.agentPropertiesIds?.length || 0;

    return this.gridItem.type == 4 && agentsCount > 0 && propsCount > 0;
  }

  constructor(private DashboardsService: DashboardService, private i18nextPipe: I18NextPipe, private differs: KeyValueDiffers) { }

  ngOnInit(): void {
    this.agents$ = this.DashboardsService.getAllAgents();
    this.agentProperties$ = this.DashboardsService.getAgentProperties();
    this.agentProperties$.pipe(take(1)).subscribe(p => {
      this.agentProperties = p;
    });
    setTimeout(() => this.modelChange(), 0);

    this.agentIdDiffers = this.differs.find(this.gridItem).create();

    this.agents$.subscribe(agents => {
      this.agents = agents;
      this.setManualOrderItems();
    });
  }  

  // gridItem is changed on deeper level so it cannot be detected by ngOnChanges
  ngDoCheck(): void {
    const changes = this.agentIdDiffers.diff(this.gridItem.setup.agentIds);

    if (changes && this.agents && this.agents.length) {
      this.setManualOrderItems();
    }
  }

  setManualOrderItems() {
    let agentIds: number[] = this.gridItem.setup.agentIds || [];
    this.manualRowOrderItems = this.agents.filter(agent => agentIds.includes(agent["userId"]));
  }

  nulifySetupSortingPoperties(isManualRowSortEnabled: boolean) {
    if (isManualRowSortEnabled) {
      this.gridItem.setup[SortComponent.firstLevelSetupColumnPropertyName] = null;
      this.gridItem.setup[SortComponent.firstLevelSetupDirectionPropertyName] = null;
      this.gridItem.setup[SortComponent.secondLevelSetupColumnPropertyName] = null;
      this.gridItem.setup[SortComponent.secondLevelSetupDirectionPropertyName] = null;
    } else {
      this.gridItem.setup[ManualRowSortComponent.setupPropertyName] = null;
    }
  }

  modelChange() {
    let listOfStringProp: string[] = ["FirstName", "LastName", "Name", "PhoneNumber", "ProfileName", "StatusDescription", "StatusDetails", "UsergroupName"];

    let agentsCount = this.gridItem.setup.agentIds?.length || 0;
    let propsCount = this.gridItem.setup.agentPropertiesIds?.length || 0;
    this.visualTypedisabledItems = [];

    let hasString: boolean = false;
    for (let i = 0; i < this.gridItem.setup.agentPropertiesIds?.length; i++) {
      let propName = this.agentProperties?.find(p => p.id == this.gridItem.setup.agentPropertiesIds[i]).name;
      if (listOfStringProp.indexOf(propName) > -1) {
        hasString = true;
        break;
      }
    }

    if (agentsCount === 1 && propsCount === 1) {
      this.visualTypedisabledItems = [0, 1, 2, 4];
    } else if (agentsCount > 1 && propsCount === 1) {
      if (hasString) {
        this.visualTypedisabledItems = [0, 1, 2];
      }
    } else if (agentsCount > 1 && propsCount > 1 && propsCount <= 4) {
      if (hasString) {
        this.visualTypedisabledItems = [0, 1, 2];
      }
      this.visualTypedisabledItems.push(3);
    } else if (agentsCount > 1 && propsCount > 4) {
      this.visualTypedisabledItems = [0, 1, 2, 3];
    } else if (agentsCount === 1 && propsCount > 1) {
      this.visualTypedisabledItems = [0, 1, 2];
    }

    if (this.visualTypedisabledItems.indexOf(this.gridItem.type) > -1) {
      this.gridItem.type = null;
    }

    if (!this.isEdit) {
      canculateGridItemSize(this.gridItem, Math.max(1, agentsCount, propsCount));
    }

    if (this.isEdit && this.gridItem.type === widgetType.Label) {
      canculateGridItemSize(this.gridItem, Math.max(1, agentsCount, propsCount));
    }

    let completed = agentsCount > 0 && propsCount > 0 && this.gridItem.type != null;
    this.completed.emit(completed);
  }
}
